// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /chat/list-pins.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeChatListPinsBody,
  typeChatListPinsOutput200,
} from "../../sdk/chat/postChatListPins";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildChatListPinsQueryKey(
  payload: typeChatListPinsBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`chatId:${JSON.stringify(payload.chatId)}`);
  return ["post:chat:chatListPins", "svc:messaging-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeChatListPinsOutput200,
    unknown,
    typeChatListPinsOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useChatListPins(
  payload: typeChatListPinsBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildChatListPinsQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postChatListPins(payload),
    ...resolvedOptions,
  });
}
